module.exports = __webpack_public_path__ + "@/assets/img/logo-instagram.69a36267.png";